import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod/v3'

const timeRegex = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/

const reapproCategoryFormSchema = z.object({
  name: z
    .string()
    .min(1, { message: 'Le nom est requis' })
    .max(30, { message: 'Le nom ne peut pas dépasser 30 caractères' }),
  daysBefore: z.coerce
    .number({ invalid_type_error: 'La valeur J-X doit être un nombre' })
    .min(1, { message: 'La valeur J-X doit être au moins 1' })
    .max(30, { message: 'La valeur J-X ne peut pas dépasser 30' }),
  coverageRate: z.coerce
    .number({ invalid_type_error: 'Le taux de couverture doit être un nombre' })
    .min(0, { message: 'Le taux de couverture ne peut pas être négatif' })
    .max(999, { message: 'Le taux de couverture ne peut pas dépasser 999' }),
  computeHour: z.string().regex(timeRegex, { message: 'Heure de calcul invalide' }),
  sendHour: z.string().regex(timeRegex, { message: "Heure d'envoi invalide" }),
  logHour: z.string().regex(timeRegex, { message: 'Heure de log invalide' }),
  productIds: z.array(z.number()).optional(),
})

export type ReapproCategoryForm = z.infer<typeof reapproCategoryFormSchema>

// Form hook
export const useReapproCategoryForm = (defaultValues?: Partial<ReapproCategoryForm>) => {
  const form = useForm<ReapproCategoryForm>({
    resolver: zodResolver(reapproCategoryFormSchema),
    defaultValues: {
      ...defaultValues,
    },
  })

  return form
}
